<template>
  <div v-if="isReady" class="panel-body">
    <transition name="fade-expand" mode="out-in">
      <div v-if="!selectedSale" key="close">
        <p class="text-size-20">募集終了したセール</p>
        <base-table :columns="columns"  :data="salesData" key="table">
          <template slot="saleName" slot-scope="props">
            <div class="text-gray">
              セールID：{{ props.rowData.saleId }}
            </div>
            <div>
              <a @click.stop="handleEditSaleEntry(props.rowData)" class="text--underline font-bold">
                {{ props.rowData.saleName }}
              </a>
            </div>
          </template>
          <template slot="appPeriodDate" slot-scope="props">
            <div class="max-content">{{ formatDate(props.rowData.applicationPeriodFrom, props.rowData.applicationPeriodTo) }}</div>
          </template>
          <template slot="eventPeriodDate" slot-scope="props">
            <div class="max-content">{{ formatDate(props.rowData.eventPeriodFrom, props.rowData.eventPeriodTo) }}</div>
          </template>
          <template slot="target" slot-scope="props">
            <div class="max-content">{{ props.rowData.target }}</div>
          </template>
        </base-table>
      </div>
      <div v-else key="entry">
        <sale-entry :selectedSale="selectedSale" @backToTop="backToTop"/>
      </div>
    </transition>
  </div>
</template>

<script>
import moment from 'moment'
import SaleService from '@/services/salemasterservice'
import BaseTable from './components/BaseTable'
import SaleEntry from './SaleEntry'
import EventService from '@/services/eventservice'
import eventCode from '@/common/event-code'

export default {
  components: {
    BaseTable,
    SaleEntry
  },
  data () {
    return {
      isReady: false,
      salesData: [],
      columns: [
        {
          title: 'セール',
          name: 'saleName'
        },
        {
          title: '募集期間',
          name: 'appPeriodDate'
        },
        {
          title: '開催期間',
          name: 'eventPeriodDate'
        },
        {
          title: '参加条件',
          name: 'target'
        }
      ]
    }
  },
  computed: {
    tab () {
      return this.$route.params.tab
    },
    saleId () {
      return this.$route.params.saleId
    },
    selectedSale () {
      return this.salesData.find(i => i.saleId === this.saleId)
    }
  },
  created () {
    this.getSaleClosed()
  },
  methods: {
    async getSaleClosed () {
      this.loader = this.$loading.show()
      await SaleService.getSaleClosed()
        .then((response) => {
          this.salesData = response.data
          this.isReady = true
        })
        .catch((error) => {
          this.$events.fire('handleError', error)
        })
        .finally(() => {
          this.loader && this.loader.hide()
        })
    },
    handleEditSaleEntry (sale) {
      this.$router.push({
        name: 'Sale',
        params: { tab: this.tab, saleId: sale.saleId }
      })
    },
    backToTop () {
      this.$router.replace({name: 'Sale', tab: this.tab, saleId: ''})
    },
    formatDate (from, to) {
      if (!from || !to) {
        return ''
      }
      const fromDate = moment(from).format('YYYY/M/D HH:mm:ss')
      const toDate = moment(to).format('YYYY/M/D HH:mm:ss')
      return `${fromDate} ～ ${toDate}`
    }
  },
  mounted () {
    let logParams = {
      name: eventCode.sale.closed,
      properties: {}
    }
    EventService.postTrackLog(logParams)
  }
}
</script>



// WEBPACK FOOTER //
// src/view/sale/SaleClosed.vue